export function OutlineHomeIcon({
  width = 24,
  height = 24,
  fill = 'none',
  stroke = 'currentColor',
  strokeWidth = 2,
}: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M22 13.47H19V19.47C19 20.57 18.1 21.47 17 21.47H14V16.47H10V21.47H7C5.9 21.47 5 20.57 5 19.47V13.47H2L10.49 3.69C11.29 2.77 12.71 2.77 13.51 3.69L22 13.47Z"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
